import { Instagram, ArrowUpRight } from "lucide-react";
import { LOGO_URL, INSTAGRAM_URL } from "../data";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-black/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <div className="max-w-md">
            <div className="flex items-center mb-5">
              <img src={LOGO_URL} alt="Aestrics Studio" className="h-16 w-auto" />
            </div>
            <p className="text-[#52525B] leading-relaxed">
              Premium websites for ambitious brands. Designed to look the part and built to convert.
            </p>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-6 inline-flex items-center gap-2 aes-gradient text-white text-sm font-medium px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity"
            >
              Get a Free Demo <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 sm:gap-16">
            <div>
              <span className="text-xs font-medium text-[#A1A1AA] tracking-wide uppercase">Explore</span>
              <ul className="mt-4 space-y-3">
                {[
                  { label: "Work", href: "#work" },
                  { label: "Process", href: "#process" },
                  { label: "Contact", href: "#contact" },
                ].map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-[#52525B] hover:text-[#0A0A0A] transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <span className="text-xs font-medium text-[#A1A1AA] tracking-wide uppercase">Social</span>
              <ul className="mt-4 space-y-3">
                <li>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram"
                    className="inline-flex items-center gap-2 text-[#52525B] hover:text-[#0A0A0A] transition-colors"
                  >
                    <Instagram className="h-4 w-4" /> Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-black/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#A1A1AA]">© {new Date().getFullYear()} Aestrics Studio. All rights reserved.</p>
          <p className="text-sm text-[#A1A1AA]">Designed & built by Aestrics Studio.</p>
        </div>
      </div>
    </footer>
  );
};
